export default __webpack_public_path__ + "static/media/logo.297251a4.svg";